module.exports = __webpack_public_path__ + "static/icon-YouTube-e2ecd83af99d5148d8614b588160a698.png";